export default "__VITE_ASSET__BksBGCbI__"